module.exports = __webpack_public_path__ + "static/img/2.d3f3543.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/zh/2.png
// module id = i0Dm
// module chunks = 0